import { Calendar, AlertCircle, Home, FileText, DollarSign } from 'lucide-react';

export const quizQuestions = [
  {
    id: 1,
    question: "What is the age of your current roof?",
    icon: Calendar,
    options: [
      { value: 'under-10', label: 'Under 10 years', score: 1 },
      { value: '10-20', label: '10-20 years', score: 2 },
      { value: '20-30', label: '20-30 years', score: 3 },
      { value: 'over-30', label: 'Over 30 years', score: 4 },
      { value: 'unknown', label: "I don't know", score: 2 }
    ]
  },
  {
    id: 2,
    question: "Have you noticed any of these issues?",
    icon: AlertCircle,
    multiple: true,
    options: [
      { value: 'leaks', label: 'Water leaks or stains', score: 4 },
      { value: 'missing', label: 'Missing or damaged shingles/tiles', score: 3 },
      { value: 'sagging', label: 'Sagging or uneven areas', score: 4 },
      { value: 'rust', label: 'Rust or corrosion', score: 3 },
      { value: 'none', label: 'No visible issues', score: 0 }
    ]
  },
  {
    id: 3,
    question: "What type of roof do you currently have?",
    icon: Home,
    options: [
      { value: 'tile', label: 'Terracotta or concrete tiles', score: 0 },
      { value: 'metal', label: 'Metal roofing', score: 0 },
      { value: 'asbestos', label: 'Asbestos (needs urgent attention)', score: 5 },
      { value: 'other', label: 'Other/Not sure', score: 0 }
    ]
  },
  {
    id: 4,
    question: "When was your last roof inspection?",
    icon: FileText,
    options: [
      { value: 'recent', label: 'Within the last year', score: 0 },
      { value: '1-3', label: '1-3 years ago', score: 1 },
      { value: '3-5', label: '3-5 years ago', score: 2 },
      { value: 'over-5', label: 'Over 5 years ago', score: 3 },
      { value: 'never', label: 'Never had one', score: 3 }
    ]
  },
  {
    id: 5,
    question: "What's your main concern?",
    icon: DollarSign,
    options: [
      { value: 'prevention', label: 'Preventative maintenance', score: 1 },
      { value: 'repair', label: 'Fix specific issues', score: 2 },
      { value: 'upgrade', label: 'Upgrade/modernize', score: 2 },
      { value: 'urgent', label: 'Emergency repair needed', score: 4 },
      { value: 'replacement', label: 'Complete replacement', score: 3 }
    ]
  }
];

export const getRecommendation = (score) => {
  if (score <= 5) {
    return {
      title: "Maintenance Recommended",
      description: "Your roof appears to be in good condition. Regular maintenance will help extend its lifespan.",
      action: "Schedule a routine inspection to keep your roof in optimal condition.",
      service: "Maintenance Services",
      urgency: "low",
      color: "text-green-600",
      bgColor: "bg-green-50",
      borderColor: "border-green-200"
    };
  } else if (score <= 10) {
    return {
      title: "Repairs Needed",
      description: "Your roof shows signs of wear that should be addressed soon to prevent further damage.",
      action: "Book a professional inspection to assess repair needs.",
      service: "Roof Repair Services",
      urgency: "medium",
      color: "text-yellow-600",
      bgColor: "bg-yellow-50",
      borderColor: "border-yellow-200"
    };
  } else {
    return {
      title: "Replacement Recommended",
      description: "Based on your responses, a roof replacement may be the most cost-effective solution.",
      action: "Get a free quote for roof replacement to protect your investment.",
      service: "Complete Roof Replacement",
      urgency: "high",
      color: "text-red-600",
      bgColor: "bg-red-50",
      borderColor: "border-red-200"
    };
  }
};

export const calculateScore = (answers, questions) => {
  let totalScore = 0;
  Object.entries(answers).forEach(([questionId, selectedValues]) => {
    const question = questions.find(q => q.id === parseInt(questionId));
    selectedValues.forEach(value => {
      const option = question.options.find(opt => opt.value === value);
      if (option) totalScore += option.score;
    });
  });
  return totalScore;
};
